import {Badge} from "@mantine/core";

export const StatusBadge = ({status}: { status: string }) => {
    let color = 'blue';
    if (status === 'Active') {
        color = 'green';
    } else if (status === 'Deprecated') {
        color = 'gray';
    }
    return <Badge color={color}>{status}</Badge>;
};
